import React from "react";
import { clearChunkReloadGuard, isChunkLoadError, tryRecoverFromChunkError } from "../../utils/chunkError";

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, isChunkError: isChunkLoadError(error) };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error)) {
      tryRecoverFromChunkError(error);
    }
  }

  handleReload = () => {
    clearChunkReloadGuard();
    window.location.reload();
  };

  render() {
    if (this.state.hasError && this.state.isChunkError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            background: "#f5f5f5",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 520,
              background: "#fff",
              border: "1px solid #f0f0f0",
              borderRadius: 10,
              padding: 24,
              textAlign: "center",
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: 8 }}>
              Atualização disponível
            </h2>
            <p style={{ margin: 0, color: "#666" }}>
              O aplicativo foi atualizado e precisa recarregar para continuar.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                marginTop: 16,
                background: "#1677ff",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                padding: "10px 16px",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Recarregar agora
            </button>
          </div>
        </div>
      );
    }

    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              background: "#1677ff",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "10px 16px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Recarregar aplicação
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
